import {Component, Input, Output, EventEmitter} from '@angular/core';

/**
 * Dropdown for selection of the msp - measure service provider (Messdienstleister)
 */
@Component({
    selector: 'app-msp',
    templateUrl: './msp.component.html',
    standalone: false
})
export class MspComponent {

  /**
   * The modelobject where the value should be set at
   */
  @Input() model: string;

  /**
   * Eventemitter when the value changes
   */
  @Output() modelChange: EventEmitter<string> = new EventEmitter<string>();

  msps = ['bfw', 'brunata', 'ista', 'kalo', 'minol', 'techem', 'sonstige'];

  /**
   * called when the value is changed
   */
  onChange(): void {
    this.modelChange.emit(this.model);
  }
}
